export default {"src":"/_next/static/media/Oracle.082ea051.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};